import type {
  ChatbotHistoryMessage,
  ChatbotHistoryMessageFile,
  ChatbotFileEvent,
  ChatbotMessage,
} from '@/models/chatbot';
import { parseStoppedContent } from '../stoppedResponse';

const mapHistoryFile = (file: ChatbotHistoryMessageFile): ChatbotFileEvent => ({
  type: 'file',
  url: file.url,
  filename: file.filename,
  size_bytes: file.size_bytes,
});

export const mapHistoryMessagesToStore = (
  messages: ChatbotHistoryMessage[],
  now: () => number = Date.now,
): ChatbotMessage[] =>
  messages.map((message, index) => {
    const timestampSeconds = typeof message.timestamp === 'number' ? message.timestamp : now() / 1000;
    const id = typeof message.timestamp === 'number' ? `history-${index}-${message.timestamp}` : `history-${index}`;
    const role = message.role === 'user' ? 'user' : 'ai';
    const { content, interrupted } =
      role === 'ai' ? parseStoppedContent(message.content) : { content: message.content, interrupted: false };

    return {
      id,
      role,
      content,
      timestamp: Math.round(timestampSeconds * 1000),
      ...(message.files?.length ? { files: message.files.map(mapHistoryFile) } : {}),
      ...(message.reasoning_steps?.length ? { reasoningSteps: message.reasoning_steps } : {}),
      ...(interrupted ? { interrupted: 'history' } : {}),
    };
  });
